// extracted by mini-css-extract-plugin
export default {"wrapper":"KeywordsViewer_wrapper__VcVxK","keywords":"KeywordsViewer_keywords__jND7N"};